export default {
  state: {
    searchProducts: [],
    search: false,
  },
  mutations: {
    setSearchProducts(state, payload) {
      state.searchProducts = payload;
    },
    setSearch(state, payload) {
      state.search = payload;
    },
  },
  actions: {
    setSearchProducts(context, payload) {
      context.commit('setSearchProducts', payload);
      context.commit('setSearch', true);
    },
    setSearch(context, payload) {
      context.commit('setSearch', payload);
    },
  },
  getters: {
    getSearchProducts(state) {
      return state.searchProducts;
    },
    getSearch(state) {
      return state.search;
    },
  },
}